<div class="section-middle mx-auto flex-grow-1">
    <div class="section-middle flex flex-column align-items-center">
        <div class="edit-img mb-5">
            <img src="/assets/media/icons/empty-page.svg">
        </div>
        <div class="title-section sgdf-heading-2 text-center sgdf-weight-medium">
            {{title}}
        </div>
        <p class="text-center">{{description}}</p>
    </div>
</div>
